import MainLayout from "@/components/layout/admin/MainLayout.vue";
import AdvancedLaravelVuePaginate from 'advanced-laravel-vue-paginate';
import 'advanced-laravel-vue-paginate/dist/advanced-laravel-vue-paginate.css';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import CONFIG from "@/assets/js/config.js";
import axios from "axios";

export default {
  name: "LeaveTypeList",
  components: {
    MainLayout,
    AdvancedLaravelVuePaginate,
    Loading
  },

  data() {
    return {
      isFilterOpen: false,
      noDataMsg: CONFIG.NO_DATA_FOUND,
      isLoading: false,
      search_status: false,
      leave_type: "",
      description: "",
      leaveTypeData: {},
      searchData: {
        status: null,
      },
      STATUS: CONFIG.LEAVE_TYPE_STATUS,
      CONFIG,
      searchedData: null,
      isSearched: false,
    };
  },

  methods: {
    reset() {
      this.leave_type = '';
      this.searchData = {
        status: null
      };
      this.search_status = false;
      this.isSearched = false;
      this.searchedData = null;
      this.isLoading = true;
      this.getAllLeaveType();
    },

    searchLeaveType(page = 1) {
      const params = {
        leave_type: this.leave_type,
        status: this.searchData.status,
        is_search: 1,
      };
      this.searchedData = { ...params };

      this.search_status = true;
      this.isLoading = true;
      this.isSearched = true;
      axios.get('leaveType/search?page=' + page, { params }) 
      .then(res => {
        if (res.data) {
          this.leaveTypeData = res.data;
        }
        this.isLoading = false;
      }).catch(error => {
        if (error.response.status == 401) {
          this.$store.commit('logout');
          window.location.replace('login');
        }
        this.isLoading = false;
      });
    },

    getAllLeaveType(page = 1) {
      axios.get('leaveType/list?page=' + page)
      .then((response) => {
        this.leaveTypeData = response.data;
        this.isLoading = false;
      }) .catch((error) => {
        if (error.response.status == 401) {
          this.$store.commit('logout');
          window.location.replace('login');
        }
        this.isLoading = false;
      });
    },

    showCreate() {
      this.$router.push({
        path: "/leaveType/create"
      });
    },

    showEdit(id) {
      this.$router.push({
        name: "leaveTypeEdit",
        params: {
          id: id
        }
      });
    },

    showDetail(id) {
      this.$router.push({
        name: "leaveTypeDetail",
        params: {
          id: id
        }
      });
    },

    confirmDelete(id) {
      if (window.confirm("Are you sure you want to delete?")) {
        this.deleteLeaveType(id);
      }
    },

    deleteLeaveType(id) {
      this.isLoading = true;
      axios.delete("/leaveType/delete/" + id)
      .then(response => {
        if (response.data.success == true) {
          this.getAllLeaveType();
          this.$notification.success('Leave Type Deleted Successfully', {
            timer: 3,
            position: "bottomCenter"
          });
        } else {
          const errorMsg = response.data.message;
          this.$notification.error(errorMsg, {
            timer: 3,
            position: "bottomCenter"
          });
          this.getAllLeaveType();
        }
      }) .catch(error => {
        if (error.response.status == 401) {
          this.$store.commit('logout');
          window.location.replace('login');
        }
        this.isLoading = false;
        console.log("Leave Type Delete Error->", error.response.data);
      });
    },

    excelDownload() {
      this.isLoading = true;
      const params = this.isSearched && this.searchedData
        ? this.searchedData
        : {
            leave_type: "",
            status: null,
          };
      axios.get('/leaveType/excelDownload', {
        params,
        responseType: 'arraybuffer'
      }) .then(response => {
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement('a');
        fileLink.href = fileURL;
        let date = new Date();
        fileLink.setAttribute('download', `leave_type_list_${date.getFullYear()}${(date.getMonth() + 1) < 9 ? 0 : ''}${(date.getMonth() + 1)}${date.getDate() < 9 ? 0 : ''}${date.getDate()}.xlsx`);
        document.body.appendChild(fileLink);
        fileLink.click();
        this.isLoading = false;
      }).catch(error => {
        if (error.response.status == 401) {
          this.$store.commit('logout');
          window.location.replace('login');
        }
        this.isLoading = false;
      });
    }
  },

  mounted() {
    this.isLoading = true;
    this.getAllLeaveType();
  },
};
